import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SessionService } from "../../services/session.service";
import { from, Observable, throwError } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { Const } from "../../data/models/const";
import { AuthService } from "../../services/auth/auth.service";
import { AlertMessage } from "../../constants/messages/alert-message";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  /**
   * コンストラクタ
   */
  constructor(
    private authService: AuthService,
    private sessionService: SessionService
  ) {}

  /**
   * API用Interceptor
   * - リクエスト前
   *    - セッションのチェック
   * - レスポンス後
   *    - アカウントロックのチェック
   *
   * - 備考
   *    - 認証か未認証か、どのAPIかなどで分岐するのは難しいので、それは各APIで行う。
   * @param req
   * @param next
   * @returns
   */
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // レスポンスの共通処理
    const _res = next.handle(req).pipe(
      tap(
        (response) => {
          // 特になし
        },
        (error) => {
          console.error("APIレスポンスエラー");
          console.error(error);

          // アカウントロックのハンドリング
          if (error.error.code == "AccountLockError") {
            alert(AlertMessage.ACCOUNT_LOCKED_MESSAGE);
            Const.release();
            this.authService.signOut();
          }
        }
      )
    );

    // ログアウトされていなければ、セッションチェックをしてから上記API共通部分を返す
    if (Const.loginUser != null) {
      return from(this.sessionService.checkSession()).pipe(
        switchMap((result) => {
          if (result) {
            return _res;
          } else {
            throwError("API実行前エラー");
            return;
          }
        })
      );
    } else {
      return _res;
    }
  }
}
